import _ from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FormSection, getFormValues } from 'redux-form';
import { isDateStringFormat, isThaiMoney, isNumber } from 'src/utils/CustomValidators';
import { DateField, RadioField, TextField } from 'src/components/Form';
import { getRadioOptions } from 'src/reducers/selectOptions';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import styles from './ProbationSetting.scss';

const ProbationSetting = props => {
  const { t } = useTranslation();
  const { probationTaxOptions, probationSalaryTypes, probationSalaryType } = props;
  const AMOUNT_VALUE = 'amount';
  const [useBasicSalary, setUseBasicSalary] = React.useState(true);

  const toggleProbationSalaryType = e => {
    if (e.target.value === AMOUNT_VALUE) {
      setUseBasicSalary(true);
    } else {
      setUseBasicSalary(false);
    }
  };

  useEffect(
    () => {
      if (probationSalaryType === AMOUNT_VALUE) {
        setUseBasicSalary(true);
      } else {
        setUseBasicSalary(false);
      }
    },
    [probationSalaryType]
  );

  return (
    <div>
      <FormSection name="employeeProbationSetting">
        <DateField
          label={t('features.Employees.components.ProbationSetting.probation_end')}
          viewMode="months"
          name="probationEnd"
          validate={isDateStringFormat}
        />

        <RadioField label={t('features.Employees.components.ProbationSetting.probation_tax_setting')} name="taxSetting" options={probationTaxOptions} />

        <RadioField
          label={t('features.Employees.components.ProbationSetting.probation_salary_type')}
          name="salaryType"
          options={probationSalaryTypes}
          onChange={toggleProbationSalaryType}
        />

        {useBasicSalary && (
          <TextField
            label={t('features.Employees.components.ProbationSetting.probation_base_salary')}
            type="text"
            name="baseSalary"
            validate={isThaiMoney}
            yen
          />
        )}

        {!useBasicSalary && (
          <TextField
            label={t('features.Employees.components.ProbationSetting.probation_salary_rate')}
            className={styles.probation_salary_rate}
            type="text"
            name="salaryRate"
            icons="%"
            validate={isNumber}
            note={<p>{t('features.Employees.components.ProbationSetting.probation_salary_rate_note')}</p>}
          />
        )}
      </FormSection>
    </div>
  );
};

const mapStateToProps = state => ({
  probationTaxOptions: getRadioOptions(state, 'probationTaxOptions'),
  probationSalaryTypes: getRadioOptions(state, 'probationSalaryTypes'),
  probationSalaryType: _.get(getFormValues(EMPLOYEE_FORM)(state).employeeProbationSetting, 'salaryType', 'amount'),
  employeeProbationSetting: getFormValues(EMPLOYEE_FORM)(state).employeeProbationSetting
});

export default connect(mapStateToProps)(ProbationSetting);
